module.exports = __webpack_public_path__ + "static/img/img_cabinet.c31e1cbb.png";